<template>
    <div name="share-modal" class="wrapper">
        <div class="modal">
            <div class="touch" @click="onClose">

            </div>
            <div class="contents">
                <img @click="onClose" class="close-button" src="../../assets/close.png" />
                <span class="title">공유 방법을 선택해 주세요</span>
                <button class="kakao-button" style="margin-top: 40px;" @click="kakao">
                        <img style="width: 22px; height: 22px; margin-right: 8px;" src="../../assets/kakao.png"/>
                        <span>카카오톡 공유</span>
                </button>
                <button class="copy-button" style="margin-top: 16px;" @click="copy">
                        <img style="width: 22px;margin-right: 8px;" src="../../assets/share2.png"/>
                        <div style="width: 87px; text-align: center">URL 복사</div>
                </button>
            </div> 
        </div>
    </div>
</template>

<script>
export default {
    name: 'shareModal',
    props: ['pharmacy'],
    data: function()
    {
        return {
            medicines: []
        }
    },
    mounted: function()
    {
        this.viewMedicines(this.pharmacy.medicines);
    },
    methods:{
        viewMedicines: function(data)
        {
            if(data !== null  || data !== '')
            {
                this.medicines = [];
                const dd = data.split(", ");
                dd.forEach(element => {
                    if(element !== '확인필요')
                    {
                        this.medicines.push(element)
                    }
                   
                });
            }

        },
        onClose: function()
        {
            this.$emit('onClose')
        },
        kakao: function()
        {
            const address = this.pharmacy.address.split(" ");
            
            let address2 = "";
            if(address.length > 1)
            {
                address2 = `${address[0]} ${address[1]}`
            }
            else
            {
                address2 = this.pharmacy.address
            }

            let medicines2 = "";

            if(this.medicines.length > 1)
            {
                medicines2 = `- ${this.medicines[0]}, ${this.medicines[1]} 등`
            }
            else if (this.medicines.length === 1)
            {
                medicines2 = `- ${this.medicines[0]}`
            }
            else 
            {
                medicines2 = "";
            }

            this.$emit('onClose')

            Kakao.Share.sendDefault({
                objectType: 'text',
                text: `[전국 인슐린 약국 지도]\n\n1형당뇨 환우들의 제보로 함께 만든,\n인슐린 취급 약국 정보를 확인해보세요.\n\n💉 ${address2} ‘${this.pharmacy.name}’ ${medicines2}\n\n이 지도는 한국1형당뇨병환우회와 솔닥컨시어지 사용자 제보로 완성되었습니다.\n주변에 인슐린이 필요한 분이 있다면 공유해주세요!`,
                link: {
                    mobileWebUrl: `${process.env.LOGIN_URI}/detail/${this.pharmacy.index}`,
                    webUrl: `${process.env.LOGIN_URI}/detail/${this.pharmacy.index}`,
                },
            });
        },
        copy: function()
        {

            const address = this.pharmacy.address.split(" ");
            let address2 = "";
            if(address.length > 1)
            {
                address2 = `${address[0]} ${address[1]}`
            }
            else
            {
                address2 = this.pharmacy.address
            }

            let medicines2 = "";

            if(this.medicines.length > 1)
            {
                medicines2 = `- ${this.medicines[0]}, ${this.medicines[1]} 등`
            }
            else if (this.medicines.length === 1)
            {
                medicines2 = `- ${this.medicines[0]}`
            }
            else 
            {
                medicines2 = "";
            }

            this.isShareModal = false;
            let text = `[전국 인슐린 약국 지도]\n\n1형당뇨 환우들의 제보로 함께 만든,\n인슐린 취급 약국 정보를 확인해보세요.\n\n💉 ${address2} ‘${this.pharmacy.name}’ ${medicines2}\n\n이 지도는 한국1형당뇨병환우회와 솔닥컨시어지 사용자 제보로 완성되었습니다.\n주변에 인슐린이 필요한 분이 있다면 공유해주세요!\n\n${process.env.LOGIN_URI}/detail/${this.pharmacy.index}`


            navigator.clipboard.writeText(text)
                .then(() => {
                    // console.log("클립보드에 복사되었습니다:");
                    alert("URL이 복사되었습니다.\n원하는 곳에 붙여넣기 해주세요.")
                })
                .catch(err => {
                    console.error("복사 실패:", err);
                });

            this.$emit('onClose')
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        box-sizing: border-box;
        z-index: 9999;
    }
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 10;
        bottom: 0;
        box-sizing: border-box;

    }
    .touch {
        height: calc(100vh - 258px);
        width: 100%;
    }
    .contents {
        background: #FFFFFF;
        height: 258px;
        width: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 34px 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        position: relative;
    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 116.667% */
    }
    .kakao-button {
        width: 100%;
        height: 55px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        background: #FFE601;
        border: none;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        cursor: pointer;
    }
    .copy-button {
        width: 100%;
        height: 55px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-20, #F3F5F8);
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        cursor: pointer;
    }

    .close-button {
        position: absolute;
        right: 16px;
        top: 30px;
        cursor: pointer;
        width: 22px;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/ShareModal.vue